import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PlacementSolutionDetailsContent } from 'app/modules/wallforming/components/setting-container/automated-placement/PlacementSolutionDetailsContent';

import type { PlacementSolution } from 'api/models';

interface PlacementSolutionDetailsProps {
    index: number;
    solution: PlacementSolution;
    isApplied: boolean;
}

export const PlacementSolutionDetails = ({ index, solution, isApplied }: PlacementSolutionDetailsProps) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Menu
            closeDelay={100}
            openDelay={0}
            position="top-end"
            shadow="md"
            withArrow
            onClose={() => setIsOpen(false)}
            onOpen={() => setIsOpen(true)}
        >
            <Menu.Target>
                <Tooltip label={t('details')} position="top">
                    <ActionIcon
                        className="bg-transparent hover:bg-background-gray-light pointer-events-auto action-icon-small"
                        onPointerDown={(event) => event.stopPropagation()}
                    >
                        <Icon color="text-text-accent" icon="more_horiz" size="lg" />
                    </ActionIcon>
                </Tooltip>
            </Menu.Target>
            <Menu.Dropdown className="min-w-72 overflow-hidden border border-border-ultra-light bg-background-default p-0! m-0!">
                {isOpen && <PlacementSolutionDetailsContent index={index} isApplied={isApplied} solution={solution} />}
            </Menu.Dropdown>
        </Menu>
    );
};
